
import { BCMSRecord, useBCMSContext, useParams, useRoute, useWorkflowStep } from "@bcm-dev/bcms-vite";
import { UICancelButton, UIPrimaryButton } from "components/ui/UIButton";
import { getDefault, getWorkflowSteps } from "components/workflows/OneTimePaymentWorkFlow";
import Classes, { Card, LinkedAccount, Transaction } from "model";
import React from "react";
import { SVGAsset } from "res";
import OneTimeDetailsWidget from "../OneTimeDetailsWidget";


/**
 * @function OneTimeReviewView
 * @return {React.Component}
 * @exported true
 * @description This is the second step in the one time payment workflow.
 */
export default function OneTimeReviewView(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor([ Card ,LinkedAccount,Transaction ], globalController);   
    const workflowStep = useWorkflowStep(getDefault, getWorkflowSteps);
    const details = workflowStep.getStepState;
    const account =  LinkedAccount.initByID(details.account ? details.account.id :1)
   const fiName = account.fi_name ?? "[FI Name]";
    const acctType = account.type ?? "[Account Type]";
    const lastFour = account.last_four_digit_number ?? "[Account Number]";
    const defaultCard =   globalController.state.branding.options.include_debit_chw23  !== "false" ? "0" : "1";
    const cardID = useParams().cardID ?? defaultCard;
    const card = Card.initByID(cardID);
    const navigate = useRoute();

    const next = evt => {
        const newTransaction = Transaction.init({
            "id":Transaction.nextID(),
        "merchant":"18",
        "amount":details.amount ??  100,
        "last_four_digit_number":lastFour,
        "routing_number":account.routing_number,
        "status":"Processing",
        "type":acctType,
        "card":cardID,
        account:"0",
        "credit":"true",
        "disputeTransaction":"false",
         "disputeTransactionType":"0",
         purchaseDate: details.date ? details.date.diff(): 1
          })
          
        
        BCMSRecord.batch([
            Transaction.create(newTransaction),
          
         
        ],globalController, Classes);
        
        workflowStep.workflow.nextStep( workflowStep.getStepState)
       
    };
    return (
        <div className="one-time-review-view">
            <div className="flex-container flex-vertical">
                <div className="flex-width circle-icon">
                    <div className="framed-icon-container">
                        <SVGAsset id="CheckingAccountIcon" />
                    </div>
                </div>
                <div className="flex-width header">
                    <p className="text-center"><b>Review Details</b></p>
                </div>
            </div>

            <OneTimeDetailsWidget details ={workflowStep.getStepState}/>

            <div className="flex-container flex-horizontal align-center-container info-container">
                <div className="set-width left-icon-container">
                    <SVGAsset id="InformationIcon" />
                </div>
                <div className="flex-width">
                    <span className="sub-text">By selecting Pay, I electronically consent and authorize the above one-time electronic funds transfer from my payment account to my credit card account.</span>
                </div>
            </div>
            <div className="flex-container flex-vertical all-center-container button-container">
                <UIPrimaryButton text="Pay" onClick={next} />
                <UICancelButton text="Cancel" onClick={()=>navigate(-1)}/>
            </div>
        </div>
    )
}
